import { render, staticRenderFns } from "./ModalResetPassword.vue?vue&type=template&id=ac58c5dc&scoped=true"
import script from "./ModalResetPassword.vue?vue&type=script&lang=js"
export * from "./ModalResetPassword.vue?vue&type=script&lang=js"
import style0 from "./ModalResetPassword.vue?vue&type=style&index=0&id=ac58c5dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac58c5dc",
  null
  
)

export default component.exports